<template>
  <div class="">
    <div class="flex about-us-section-1">
      <div class="row mt-3">
        <div class="col-lg-5 col-sm-12 mt-5">
          <img src="@/assets/about-pg-img/Banner.jpg" alt="Tank" class="rounded-5 tank-img" height="421" width="386" />
        </div>
        <div class="col-lg-6 about-text mt-5 col-sm-12">
          <p>
            Pratima Construction and Consultancy, established in 2016, is a leading firm specializing in water supply, drainage, and infrastructure development projects.
            
            <span v-if="!isLargeScreen && showMore[1]">
              With a strong foundation built on decades of expertise, the firm excels in delivering high-quality construction and consultancy services. Since its inception, Pratima Construction has expanded its operations to include the construction of water supply systems, sewage treatment plants, industrial infrastructure, and residential development projects. The consultancy wing, formed in 2019, focuses on the preparation of Detailed Project Reports (DPR) and project management for initiatives like the Jal Jeevan Mission.
            </span>
            <span v-if="isLargeScreen">
              With a strong foundation built on decades of expertise, the firm excels in delivering high-quality construction and consultancy services. Since its inception, Pratima Construction has expanded its operations to include the construction of water supply systems, sewage treatment plants, industrial infrastructure, and residential development projects. The consultancy wing, formed in 2019, focuses on the preparation of Detailed Project Reports (DPR) and project management for initiatives like the Jal Jeevan Mission.
            </span>
          </p>
          <button
            v-if="!isLargeScreen"
            class="read-more-btn"
            @click="toggleText(1)"
          >
            {{ showMore[1] ? "Read Less" : "Read More" }}
          </button>
        </div>
      </div>
    </div>


    <div class="about-us-section-2 rounded-5">
      <div class="text-section">
        <div class="col-12">
            <h2>Our Vision</h2>
        </div>
        <div class="col-12 mt-4">
          <p>To be a trusted leader in infrastructure development, leveraging modern technologies to create sustainable water supply, drainage, and urban development solutions for a better tomorrow.</p>
        </div>
        <div class="col-12 our-core">
            <h2>Our Core Values</h2>
        </div>
      </div>
      <div class="container">
      <div class="row justify-content-center text-center gy-5 gx-5 core-values">
        <!-- First Block -->
        <div class="col-md-4 d-flex flex-column align-items-center">
          <div class="square border border-white mb-4">
            <img src="@/assets/images/about-us-images/Quality-icon.svg" alt="" srcset="" height="100" width="100" class="mt-4">
          </div>
          <h5 class="text-white">Quality</h5>
          <p class="text-white">Commitment to superior standards in every project.</p>
        </div>
        <!-- Second Block -->
        <div class="col-md-4 d-flex flex-column align-items-center">
          <div class="square border border-white mb-4">
            <img src="@/assets/images/about-us-images/Integrity. about page.svg" alt="" srcset="" height="80" width="80" class="mt-4">
          </div>
          <h5 class="text-white">Integrity</h5>
          <p class="text-white">Upholding transparency and trust in every partnership.</p>
        </div>
        <!-- Third Block -->
        <div class="col-md-4 d-flex flex-column align-items-center">
          <div class="square border border-white mb-4">
            <img src="@/assets/images/about-us-images/community icon. about page.svg" alt="" srcset="" height="100" width="100" class="mt-4">
          </div>
          <h5 class="text-white">Community Impact</h5>
          <p class="text-white">Enhancing the quality of life in the communities we serve.</p>
        </div>
      </div>
    </div>


    </div>
    <div class="about-us-section-3">
      <div class="col-12">
        <img src="@/assets/images/sahebrao-gade-no-backgraound2.png" alt="Sahebrao Gade" height="220" width="220" class="rounded-circle" />
      </div>
      <div class="col-12 mt-3">
        <h3>The Founder</h3>
      </div>
      <div class="col-12">
        <h2>Mr. Sahebrao Shridhar Gade</h2>
      </div>
      <div class="col-12 mt-5">
        <div v-if="isLargeScreen">
          <p>A visionary leader with over three decades of extensive experience in planning, designing, and supervising infrastructure projects. He began his illustrious career in 1985 with Maharashtra Jeevan Pradhikaran, contributing to transformative water supply and drainage schemes across the state. Mr. Gade’s dedication to excellence earned him the prestigious Best Engineering Award from the Government of Maharashtra in 2012. Post his V.R.S. in 2015, he continues to guide Pratima Construction with his technical expertise, focusing on innovative solutions for water supply, drainage, and urban development projects.</p>
          <p>Under his leadership, Pratima Construction has achieved numerous milestones, reflecting his passion for engineering excellence and sustainable growth. His hands-on approach and strategic vision have been instrumental in driving the firm’s success in complex and large-scale projects, inspiring a team dedicated to delivering impactful solutions.</p>
        </div>
        <div v-else>
          <p>
            A visionary leader with over three decades of extensive experience in planning, designing, and supervising infrastructure projects. He began his illustrious career in 1985 with Maharashtra Jeevan Pradhikaran, contributing to transformative water supply and drainage schemes across the state.
            <span v-if="showMore[2]">
              Mr. Gade’s dedication to excellence earned him the prestigious Best Engineering Award from the Government of Maharashtra in 2012. Post his V.R.S. in 2015, he continues to guide Pratima Construction with his technical expertise, focusing on innovative solutions for water supply, drainage, and urban development projects. Under his leadership, Pratima Construction has achieved numerous milestones, reflecting his passion for engineering excellence and sustainable growth. His hands-on approach and strategic vision have been instrumental in driving the firm’s success in complex and large-scale projects, inspiring a team dedicated to delivering impactful solutions.
            </span>
          </p>
          <button class="read-more-btn" @click="toggleText(2)">
            {{ showMore[2] ? "Read Less" : "Read More" }}
          </button>
        </div>
      </div>
    </div>
    <div class="about-us-section-4">
      <div class="col-lg-12 mt-3">
        <h2>Awards</h2>
      </div>
      <div class="container">
        <div class="d-flex flex-row custom-card rounded-5">
          <swiper
              class="swiper"
              :modules="modules"
              :space-between="1"
              :slides-per-view="1"
              :free-mode="true"
              :autoplay="{
                delay: 1000,
                disableOnInteraction: false
              }"
              :breakpoints="{
                  320: {
                    slidesPerView: 1, // Very small screens
                    spaceBetween: 10
                  },
                  576: {
                    slidesPerView: 1, // Small screens (sm)
                    spaceBetween: 10
                  },
                  768: {
                    slidesPerView: 2, // Medium screens (md)
                    spaceBetween: 10
                  },
                  992: {
                    slidesPerView: 2, // Large screens (lg)
                    spaceBetween: 30
                  },
                  1200: {
                    slidesPerView: 3, // Extra large screens (xl)
                    spaceBetween: 50
                  },
                  1400: {
                    slidesPerView: 3, // Very large screens
                    spaceBetween: 50
                  }
                }"
            >
              <swiper-slide class="slide" v-for="(award, index) in awardData" :key="index">
                <div class="">
                  <div class="card text-center rounded-5 border-white">
                    <img :src="award.image" class="card-img-top rounded-5 mx-auto" :alt="award.name">
                    <div class="card-body">
                      <!-- <h5 class="card-title fw-bold">{{ award.name }}</h5> -->
                      <p class="card-text ms-4 fw-light">{{ award.name  }}</p>
                    </div>
                  </div>
              </div>

              </swiper-slide>
          </swiper>
         
        </div>
      </div>
      
    </div>
    <div class="about-us-section-5">
      <div class="col-lg-12">
        <h2>Our Team</h2>
      </div>
      <div class="col-lg-12 mt-5">
        <h3>Technical Team</h3>
      </div>
      <div class="container">
        <div class="d-flex flex-row custom-card rounded-5">
          <swiper
              class="swiper"
              :modules="modules"
              :space-between="1"
              :slides-per-view="1"
              :free-mode="true"
              :autoplay="{
                delay: 1000,
                disableOnInteraction: false
              }"
              :breakpoints="{
                  320: {
                    slidesPerView: 1, // Very small screens
                    spaceBetween: 10
                  },
                  576: {
                    slidesPerView: 2, // Small screens (sm)
                    spaceBetween: 1
                  },
                  768: {
                    slidesPerView: 2, // Medium screens (md)
                    spaceBetween: 1
                  },
                  992: {
                    slidesPerView: 3, // Large screens (lg)
                    spaceBetween: 1
                  },
                  1200: {
                    slidesPerView: 4, // Extra large screens (xl)
                    spaceBetween: 1
                  },
                  1400: {
                    slidesPerView: 5, // Very large screens
                    spaceBetween: 1
                  }
                }"
            >
              <swiper-slide class="slide" v-for="(team, index) in teamData" :key="index">
                <div class="">
                  <div class="card text-center rounded-5 border-white">
                    <img :src="team.image" class="card-img-top rounded-5 mx-auto" :alt="team.name">
                    <div class="card-body">
                      <h5 class="card-title fw-bold">{{ team.name }}</h5>
                      <p class="card-text fw-light">{{ team.designation  }}</p>
                    </div>
                  </div>
              </div>

              </swiper-slide>
          </swiper>
         
        </div>
      </div>
    </div>

    <div class="about-us-section-6 d-flex flex-column justify-content-center align-items-center text-center">
    <!-- Title -->
    <div class="col-12 mb-3">
        <h2>Future Goals</h2>
    </div>

    <!-- Goals List -->
    <div class="row align-items-center mt-lg-5">
        <!-- Image Column -->
        <div class="col-lg-5 col-md-12 order-2 order-lg-1 text-center img-tag">
            <img src="@/assets/about-pg-img/goals-Mobile.png" class="img-fluid" alt="Target Illustration"> 
        </div>
        <!-- Text/List Column -->
        <div class="col-lg-6 col-md-12 order-1 order-lg-2 mt-4 text-section">
            <ul class="list-styled text-start px-3 px-lg-0">
                <li class="mb-3">
                    <i class="bi bi-check-circle-fill text-warning"></i>
                    Implement greywater and solid waste management solutions for small and medium towns.
                </li>
                <li class="mb-3">
                    <i class="bi bi-check-circle-fill text-warning"></i>
                    Undertake infrastructure development for industrial areas and residential townships using advanced technologies.
                </li>
                <li class="mb-3">
                    <i class="bi bi-check-circle-fill text-warning"></i>
                    Embrace automation and smart technologies in water supply and sewage network projects.
                </li>
            </ul>
        </div>
    </div>

    <!-- Bottom Text -->
    <div class="col-lg-9 col-md-12">
        <p>
            Pratima Construction and Consultancy thrives on the collective expertise and dedication of its talented team, ensuring successful project execution and client satisfaction. By embracing a culture of innovation, we are poised to tackle the challenges of modern infrastructure development while building a sustainable future for generations to come.
        </p>
    </div>
</div>

  </div>
</template>

<script>

import { Swiper, SwiperSlide } from 'swiper/vue'; // Import Swiper Vue components
import 'swiper/css'; // Import Swiper base styles
import 'swiper/css/pagination'; // Import Swiper pagination styles
import { Pagination, FreeMode } from 'swiper/modules'; // Import Swiper modules
import { Autoplay } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export default {
  name: "AboutUsPage",
  components:{
    Swiper,
    SwiperSlide,
  },
  methods:{
    toggleText(index) {
      if(index == 1){
        this.showMore[1] = !this.showMore[1]; // Toggle the value of showMore
      }else{
        this.showMore[2] = !this.showMore[2];
      }
    },
    updateScreenSize() {
      this.isLargeScreen = window.innerWidth > 768; // Check if screen is larger than 768px
    },

  },
  mounted() {
    this.updateScreenSize(); // Initial check
    window.addEventListener("resize", this.updateScreenSize); // Listen for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenSize); // Clean up the listener
  },
  data(){
    return{
      showMore: [false,false],
      isLargeScreen: true, // Track screen size
      modules: [Pagination, FreeMode,Autoplay], // Swiper modules are used here
      teamData:[
        {
          image: require("@/assets/about-pg-img/Bhavesh.jpg"), // Replace with actual image path
          alt: "Bhavesh Patil",
          name: "Bhavesh Patil",
          designation: "D.C.E Site Egg."
        },
        {
          image: require("@/assets/about-pg-img/Sayali.jpg"), // Replace with actual image path
          alt: "Sayali Jogdand",
          name: "Sayali Jogdand",
          designation: "B.E Design Egg."
        },
        {
          image: require("@/assets/about-pg-img/Anjali.jpg"), // Replace with actual image path
          alt: "Anjali Patil",
          name: "Anjali Patil",
          designation: "B.E Design Egg."
        },
        {
          image: require("@/assets/about-pg-img/Tajamul.jpg"), // Replace with actual image path
          alt: "Tajamul Gul",
          name: "Tajamul Gul",
          designation: "B.E Project Egg."
        },
        {
          image: require("@/assets/about-pg-img/Omkar.jpg"), // Replace with actual image path
          alt: "Omkar Sangamnere",
          name: "Omkar Sangamnere",
          designation: "B.E Site Egg."
        },
        {
          image: require("@/assets/about-pg-img/Ashok.jpg"), // Replace with actual image path
          alt: "Ashok Kadam",
          name: "Ashok Kadam",
          designation: "B.com Accountant"
        },
        {
          image: require("@/assets/about-pg-img/Manoj.jpg"), // Replace with actual image path
          alt: "Manoj Dhanorkar",
          name: "Manoj Dhanorkar",
          designation: "D.C.E Project Inchager"
        },
      ],

      awardData:[
        {
          image: require("@/assets/about-pg-img/award 1.png"), // Replace with actual image path
          alt: "Award",
          name: "Extraordinary work  in Maharashrta Jeevan Pradhikaran 2011",
          designation: "D.C.E Site Egg."
        },
        {
          image: require("@/assets/about-pg-img/award 2.jpg"), // Replace with actual image path
          alt: "Award",
          name: "Water Supply and Sanitation Department Gaurav Puraskar 2011",
          designation: "D.C.E Site Egg."
        },
        {
          image: require("@/assets/about-pg-img/award 3.jpg"), // Replace with actual image path
          alt: "Award",
          name: "Awarded by government of Maharashtra Abhiyanta Gurav 2012 ",
          designation: "D.C.E Site Egg."
        },
      ]

    }
  },
};
</script>

<style scoped>
/* Set a flexible height for the image */


.logo-container {
  display: none; /* Hide logo by default */
}

@media (max-width: 768px) {
  .logo-container {
    display: block; /* Show logo on smaller screens */
    text-align: center; /* Optional: center-align the logo */
  }
}

.about-us-section-1 {
  width: 100%;
  height: auto; /* Full viewport height */
  overflow: hidden;
  margin-top: 6vh;
  margin-bottom: 8.5vh;
  padding: 0px 18vh 0px 18vh;
}

.about-us-section-1 .about-text {
  font-family: 'Inter';
  font-weight: 600;
  font-size: 23px;
  line-height: 160%;
  letter-spacing: 0.05em;
  color: #166590;
  text-align: left;
}

@media (max-width: 360px) {
  .about-us-section-1 .tank-img {
    height: 250px;
    width: 250px;
  }
  .about-us-section-1 .logo-img {
    height: 100px;
    width: 250px;
  }
  .about-us-section-1 {
    padding: 0px 1vh 0px 1vh;
  }
}

@media (max-width: 990px) {
  .about-us-section-1 {
    margin-top: 1vh;
    height: auto; /* Adjust height for smaller screens */
  }
  .about-us-section-1 .about-text {
    padding: 0px 10vh 0px 10vh;
  }
}

@media (max-width: 1211px) {
  .about-us-section-1 {
    height: auto;
  }
}

@media (max-width: 578px) {
  .about-us-section-3 h2 {
    font-size: 28px !important;
  }
  .about-us-section-3 h3 {
    font-size: 25px !important;
  }
  .about-us-section-1 .about-text {
        padding: 0px 2vh;
    }
}

.read-more-btn {
  border: 1px solid #848AFF;
  color: #166590;
  /* transition: background-color 0.3s ease; */
  padding: 9px 10px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5vh;
  margin-top: 10px;
  width: 17vh;

  background: #fff;

}

.read-more-btn:hover {
  /* background: #636ae8;
  color: #fff; */
}

/* On large screens, hide the button */
@media (min-width: 769px) {
  .read-more-btn {
    display: none;
  }
}

.about-text {
  font-size: 18px;
}

/* section 2 */

.about-us-section-2{
  width: 100%;
  height: auto; 
  overflow: hidden;
  background: #848AFF;
  color: #fff;
}

.our-core{
  margin-top: 10vh;
}

.about-us-section-2 .text-section{
  margin-top: 10vh;

}

.about-us-section-2 .text-section h2{
  font-family: 'Plus Jakarta Sans';
  font-size: 48px;
  font-weight: 500;
  line-height: 60px;
  letter-spacing: -0.02em;
  text-align: center; 

}

.about-us-section-2 .text-section p{
  font-family: 'Plus Jakarta Sans';
  font-size: 28px;
  font-weight: 400;
  text-align: center;
  padding: 0px 48vh 0px 48vh;

}

.about-us-section-2 .core-values{
  padding: 0vh 5vh;
}


.square {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}

.core-values{
  margin-top: 5vh;
}

.core-values h5 {
  font-family: 'Archivo';
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;
  text-align: center;

}

.core-values p {
  font-family: 'Inter';
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

}

.about-us-section-2 .img-fluid {
  max-width: 80px; /* Control icon/image size */
  height: auto;
}
.gx-5{
  --bs-gutter-x: 4rem !important  ;
}

@media (max-width:1141px) {
  .about-us-section-2{
    height: auto; 
  }
}


.about-us-section-2 .core-values{
  padding-bottom: 5vh;
}

/* section 3 */

.about-us-section-3 img{
  background: #AEB0DD;
}

/* section 2 */

.about-us-section-3{
  width: 100%;
  height: 100vh; 
  overflow: hidden;
  margin-top: 7vh;
}

.about-us-section-3 h3, h2{
  font-family: 'Archivo';
  font-weight: 700;
  line-height: 47px;
  letter-spacing: 0.05em;
  text-align: center;
}

.about-us-section-3 h2{
  font-size: 40px;
}

.about-us-section-3 h3{
  font-size: 36px;
}

.about-us-section-3 p {
  padding: 0px 20vh;
  font-family: "Inter";
  font-size: 24px;
  font-weight: 400;
  line-height: 47px;
  letter-spacing: 0.05em;
  text-align: center;
}

@media (max-width: 768px) {
  .about-us-section-3 p {
    padding: 0px 10vh;
    font-size: 18px;
    line-height: 30px;
  }
}


@media (max-width:1504px) {
  .about-us-section-1{
      padding: 0px 8vh 0px 8vh; 
  }

  .about-us-section-2 .text-section p{
    padding: 0px 30vh 0px 30vh;
  }
  .about-us-section-3{
    height: auto;
  }
}

@media (max-width:1263px) {
  .about-us-section-1{
      padding: 0px; 
  }
  .about-us-section-2 .text-section p{
    padding: 0px 20vh 0px 20vh;
  }
}

@media (max-width:989px) {
  .about-us-section-1{
      padding: 0px 5vh 0px 5vh; 
  }
  .about-us-section-2 .text-section p{
    padding: 0px 5vh 0px 5vh;
  }
}

@media (max-width:997px) {
  .about-us-section-2{
    height: auto; 
  }
  .about-us-section-3 p{
    padding: 0px 10vh 0px 10vh;
  }
}

@media (max-width:759px) {
  .about-us-section-2{
    /* height: 190vh;  */
  }
}

@media (max-width:462px) {
  .about-us-section-2{
    /* height: 210vh;  */
  }
  .about-us-section-1 .tank-img{
    height: 290px;
    width: 330px;
  }

}



@media (max-width:387px) {
  .about-us-section-2{
    /* height: 220vh;  */
  }
  .about-us-section-1 .tank-img{
    height: 250px;
    width: 261px;
  }

  .about-us-section-1 .logo-img{
    height: 90px;
    width: 300px;
  }
}

@media (max-width: 329px) {
  .about-us-section-1 .tank-img{
    height: 200px;
    width: 230px;
  }
  .about-us-section-1 .logo-img{
    height: 90px;
    width: 25 0px;
  }
}


@media (max-width:1687px) {
  .about-us-section-3{
    height: auto;
  }
}

@media (max-width:508px) {
  .about-us-section-3 p{
    padding: 0vh 5vh;
  }
  .about-us-section-3 h2{
    padding: 0vh 5vh;
  }
}




/* sectiom 4 */


.about-us-section-4{
  /* margin-top: 22vh !important; */
  width: 100%;
  height: auto; /* Full viewport height */
  overflow: hidden;
}

.about-us-section-4 h2{
  font-weight: 600;
  font-size: 48px;
  line-height: 98%;
  letter-spacing: 0.05em;
  text-align: center;
  color: #171a1f;
  font-family: 'Archivo';

}

.about-us-section-4 p{
  font-family: 'Archivo';
  font-weight: 500;
  font-size: 22px;
  line-height: 159%;
  letter-spacing: 0.05em;
  text-align: center;
  color: #000;
}

.about-us-section-4 .card-img-top{
  width: 300px;
  height: 250px;
  top: 24px;
  border-radius: 25px;
}

.about-us-section-4 .custom-card{
  margin-top: 10vh;
  height: auto;
}

.section-4 .card-title{
  font-size: 32px;
  font-family: 'Archivo';
}

.section-4 .card-text{
  font-size: 14px;
  font-family: 'Inter';
}

@media (max-width:575px) {
  
}

.about-us-section-4 .swiper {
  height: auto; /* Let swiper adapt its height dynamically */
}

.about-us-section-4 .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-us-section-4 .swiper-slide .card {
  max-height: 200%; /* Prevent overflowing */
}

.about-us-section-4 .swiper-pagination {
    top: 41vh !important;
}

@media (min-width: 1400px) {
  .about-us-section-4 .container{
    max-width: 1352px;
  }
}


/* section 5 */

.about-us-section-5{
  /* margin-top: 22vh !important; */
  width: 100%;
  height: auto; /* Full viewport height */
  overflow: hidden;
  margin-top: 8vh;
  margin-bottom: 10vh;
}

@media (min-width: 1400px) {
  .about-us-section-5 .container{
    max-width: 1351px;
  }
}


.about-us-section-5 h2{
  font-family: 'Archivo';
  font-size: 48px;
  font-weight: 600;
  line-height: 47px;
  letter-spacing: 0.05em;
  text-align: center;
}

.about-us-section-5 h3{
  font-family: Archivo;
  font-size: 32px;
  font-weight: 600;
  line-height: 47px;
  letter-spacing: 0.05em;
  text-align: center;

}

.about-us-section-5 .card-img-top{
  width: 180px;
  height: 150px;
  top: 24px;
  border-radius: 25px;
}

.about-us-section-5 .custom-card{
  margin-top: 5vh;
  height: auto;
}

.section-4 .card-title{
  font-size: 32px;
  font-family: 'Archivo';
}

.section-4 .card-text{
  font-size: 14px;
  font-family: 'Inter';
}

@media (max-width:575px) {
  
}

.about-us-section-5 .swiper {
  height: auto; /* Let swiper adapt its height dynamically */
}

.about-us-section-5 .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.about-us-section-5 .swiper-slide .card {
  max-height: 200%; /* Prevent overflowing */
}
.about-us-section-5 .swiper-pagination {
  position: absolute !important;
  top: 26vh !important;
  margin-top: 10px;  /* Adjust as needed */
}

.about-us-section-5 .swiper {
  position: relative;
}

/* section 6 */
.about-us-section-6 {
    width: 100%;
    min-height: 80vh;
    background: #166590;
    border-radius: 48px;
    padding: 5vh 20px;
    color: #fff;
    box-sizing: border-box;
}

.about-us-section-6 h2 {
    font-family: 'Archivo', sans-serif;
    font-size: 48px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.05em;
    text-align: center;
    margin-bottom: -8vh;
}

.about-us-section-6 p {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 26px;
    line-height: 196%;
    letter-spacing: 0.05em;
    color: #fff;
    
}

.about-us-section-6 ul {
    font-family: 'Inter';
    font-weight: 600;
    font-size: 26px;
    line-height: 1.6;
    letter-spacing: 0.05em;
    color: #fff;
}

.about-us-section-6 p {
    margin-top: 0vh;
    text-align: justify;
}

.about-us-section-6 img {
    height: 528px;
    width: 519px;
    object-fit: contain;
}


.about-us-section-6 .img-tag{
  padding: 5vh 0vh 0vh 17vh;
}

.about-us-section-6 .text-section{
  padding-right: 6vh;
}


@media (max-width:991px) {
  .about-us-section-6 .text-section{
    padding: 0vh 9vh;
  }

  .about-us-section-6 p{
    padding: 0vh 9vh;
  }
  .about-us-section-6 .img-tag{
    padding: 5vh 0vh 0vh 10vh;
  }

  /* 0vh 9vh */
}

/* Medium screens (tablets) */
@media (max-width: 992px) {
    .about-us-section-6 {
        min-height: auto;
    }

    .about-us-section-6 h2 {
        font-size: 36px;
    }

    .about-us-section-6 ul, .about-us-section-6 p {
        font-size: 18px;
    }

    .about-us-section-6 img {
        margin-bottom: 3vh;
        max-height: 400px;
    }
}

/* Small screens (mobile) */
@media (max-width: 768px) {
    .about-us-section-6 h2 {
        font-size: 32px;
    }

    .about-us-section-6 ul, .about-us-section-6 p {
        font-size: 16px;
    }

    .about-us-section-6 img {
        max-height: 300px;
    }
}

/* Extra small screens */
@media (max-width: 576px) {
    .about-us-section-6 h2 {
        font-size: 28px;
    }

    .about-us-section-6 ul, .about-us-section-6 p {
        font-size: 14px;
    }

    .about-us-section-1 p {
      font-size: 18px;
    }

    .about-us-section-6 img {
        max-height: 250px;
    }

    .about-us-section-6 ul {
        padding-left: 15px;
        padding-right: 15px;
    }

    .about-us-section-6 .text-section{
      padding: 0vh 5vh;
    }

    .about-us-section-6 p{
      padding: 0vh 5vh;
    }
    .about-us-section-6 .img-tag{
      padding: 5vh 0vh 0vh 8vh;
    }


}

@media (max-width:1175px) {
  .about-us-section-6 h2{
    margin-bottom: 4vh;
  }
}


</style>
